import { cleanAndParseAiJson } from "./reinsertionHelpers";

export type GeminiWrappedPayload = {
  output: string;
  sanitizedBody: string;
};

export function parseGeminiHttpTextResponse(text: string): unknown {
  try {
    const j = JSON.parse(text) as unknown;
    if (
      j &&
      typeof j === "object" &&
      "output" in j &&
      typeof (j as GeminiWrappedPayload).output === "string" &&
      "sanitizedBody" in j &&
      typeof (j as GeminiWrappedPayload).sanitizedBody === "string"
    ) {
      const wrapped = j as GeminiWrappedPayload;
      const data = cleanAndParseAiJson(wrapped.output);
      if (
        data !== null &&
        typeof data === "object" &&
        !Array.isArray(data)
      ) {
        return { ...data, sanitizedBody: wrapped.sanitizedBody };
      }
      return {
        data,
        sanitizedBody: wrapped.sanitizedBody,
      };
    }
  } catch {
    /* plain model text */
  }
  return cleanAndParseAiJson(text);
}
